import {
  INJECT_BLOCK_ITEM,
  INJECT_EDIT_CONTEXT,
  INJECT_FIELD_LIST_BLOCKS,
  INJECT_FIELD_LIST_TYPE,
  INJECT_REUSABLE_OPTIONS,
  INJECT_PROVIDER_BLOCKS,
  INJECT_FIELD_USES_PROXY
} from "../helpers/symbols.js";
import {
  computed,
  inject,
  getCurrentInstance,
  onMounted,
  onBeforeUnmount
} from "#imports";
import { globalOptionsDefaults } from "#blokkli/default-global-options";
import { getRuntimeOptionValue } from "#blokkli/helpers/runtimeHelpers";
export function defineBlokkli(config) {
  const optionKeys = [
    ...Object.keys(config.options || {}),
    ...config.globalOptions || []
  ];
  const fieldListType = inject(
    INJECT_FIELD_LIST_TYPE,
    computed(() => "default")
  );
  const siblings = inject(
    INJECT_FIELD_LIST_BLOCKS
  );
  const rootBlocks = inject(
    INJECT_PROVIDER_BLOCKS
  );
  const item = inject(INJECT_BLOCK_ITEM);
  const uuid = item?.value.uuid || "";
  const index = item?.value.index !== void 0 ? item.value.index : computed(() => 0);
  const fromLibraryOptions = inject(
    INJECT_REUSABLE_OPTIONS,
    null
  );
  const editContext = inject(INJECT_EDIT_CONTEXT, null);
  const options = computed(() => {
    if (config.bundle === "from_library" || config.bundle === "blokkli_fragment") {
      return {
        ...item?.value.options || {},
        ...editContext?.mutatedOptions[uuid] || {}
      };
    }
    const result = optionKeys.reduce((acc, key) => {
      if (editContext) {
        const overrideOptions = editContext.mutatedOptions[uuid] || {};
        if (overrideOptions[key] !== void 0) {
          acc[key] = overrideOptions[key];
          return acc;
        }
      }
      if (fromLibraryOptions && fromLibraryOptions.value[key] !== void 0) {
        acc[key] = fromLibraryOptions.value[key];
        return acc;
      }
      if (item?.value.options && item.value.options[key] !== void 0) {
        acc[key] = item.value.options[key];
        return acc;
      }
      return acc;
    }, {});
    optionKeys.forEach((key) => {
      const definition = config.options?.[key] || globalOptionsDefaults[key];
      if (!definition) {
        return;
      }
      const value = result[key] === void 0 || result[key] === null ? definition.default : result[key];
      result[key] = getRuntimeOptionValue(definition, value);
    });
    return result;
  });
  const parentType = computed(() => item?.value.parentType);
  const isEditing = !!item?.value.isEditing;
  const fieldUsesProxy = inject(INJECT_FIELD_USES_PROXY, false);
  onMounted(() => {
    if (
      // If the field uses proxy mode we don't want to register the block here.
      fieldUsesProxy || !item?.value || !isEditing || !editContext || !editContext.dom || // Block is already registered by the from_library block.
      fromLibraryOptions || // The defineBlokkliFragment composable registers the block itself.
      config.bundle === "blokkli_fragment"
    ) {
      return;
    }
    const instance = getCurrentInstance();
    editContext.dom.registerBlock(
      uuid,
      instance,
      config.bundle,
      fieldListType.value,
      item.value.parentType
    );
  });
  onBeforeUnmount(() => {
    if (!fieldUsesProxy && isEditing && editContext && editContext.dom && uuid && config.bundle !== "blokkli_fragment") {
      editContext.dom.unregisterBlock(uuid);
    }
  });
  return {
    uuid,
    index,
    options,
    isEditing,
    parentType,
    fieldListType,
    siblings,
    rootBlocks
  };
}
